import { Typography } from '@/components/atoms/Typography/Typography';
import * as Styled from './NoProjectsFound.styled';
import { useTranslations } from 'next-intl';

interface NoProjectsFoundProps {
  isLoading?: boolean;
}

export const NoProjectsFound: React.FC<NoProjectsFoundProps> = ({
  // isLoading,
}: {
  isLoading?: boolean;
}) => {
  const t = useTranslations('work');
  const content = t.raw('filteredProjectsGallery') as {
    noResults: string;
  };

  return (
    <Styled.NoProjectsFound className='no-projects-found'>
      <Typography color="primary" text={content.noResults} size="lg" />
    </Styled.NoProjectsFound>
  );
};
